export const REACT_APP_API_URL = process.env.REACT_APP_API_URL;
export const REACT_APP_BASE_URL = process.env.REACT_APP_BASE_URL;
